export default __webpack_public_path__ + "static/media/template2.816e9c9b.png";